import { style } from "@vanilla-extract/css";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { responsive } from "@huub-web/ui/utils/responsive";

export const documentViewerStyle = style({
  width: "100%",
  padding: `calc(${theme.spacings.xxl} + ${theme.spacings.xs}) ${theme.spacings.xs} ${theme.spacings.s}`,
});

export const documentViewerIFrameContainerStyle = style({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
});

export const documentViewerIFrameStyle = style({
  width: "100%",
  flexGrow: 1,
  border: "none",
  borderRadius: `${theme.borderRadiuses.s} ${theme.borderRadiuses.s} 0 0`,
  overflow: "hidden",
  minHeight: "60vh",
});

export const documentViewerContainerStyle = style({
  gap: theme.spacings.s,
  background: theme.colors.panel,
  borderRadius: `0 0 ${theme.borderRadiuses.s} ${theme.borderRadiuses.s}`,
  padding: theme.spacings.m,
  flexDirection: "column",
  ...responsive({
    700: {
      flexDirection: "row",
    },
  }),
});
